<script lang="ts" setup>
import userStore from '@/store/UserStore.ts'
</script>

<template>
  <svg
    :class="{
      'brand-va': userStore.brand === 'VAILLANT',
      'brand-sd': userStore.brand === 'SDBG'
    }"
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg">
    <g
      id="Artboard" fill="none" fill-rule="evenodd" stroke="none"
      stroke-width="1">
      <g id="Group" stroke="#000000" stroke-width="22" transform="translate(150, 50)">
        <rect
          id="Rectangle" height="378" rx="22" width="178"
          x="11" y="11" />
        <line
          id="Line" stroke-linecap="round" stroke-linejoin="round" x1="20"
          x2="176" y1="13" y2="377" />
      </g>
      <path
        id="Line-2"
        d="M58.2971925,93 C58.8435644,93 59.3824327,93.1272096 59.8711226,93.3715545 L111.831522,119.351754 C113.570037,120.221012 114.27471,122.335029 113.405452,124.073545 C113.064901,124.754648 112.512625,125.306923 111.831522,125.647475 L59.8711226,151.627675 C58.1326074,152.496932 56.0185899,151.79226 55.1493323,150.053744 C54.9049873,149.565055 54.7777778,149.026186 54.7777778,148.479814 L54.777,128 L10.5,128 C7.46243388,128 5,125.537566 5,122.5 C5,119.462434 7.46243388,117 10.5,117 L54.777,117 L54.7777778,96.5194147 C54.7777778,94.6404863 56.2501778,93.1054553 58.1040921,93.0052076 Z"
        fill-rule="nonzero" />
      <path
        id="Line-3"
        d="M58.2971925,343.5 C58.8435644,343.5 59.3824327,343.62721 59.8711226,343.871554 L111.831522,369.851754 C113.570037,370.721012 114.27471,372.835029 113.405452,374.573545 C113.064901,375.254648 112.512625,375.806923 111.831522,376.147475 L59.8711226,402.127675 C58.1326074,402.996932 56.0185899,402.29226 55.1493323,400.553744 C54.9049873,400.065055 54.7777778,399.526186 54.7777778,398.979814 L54.777,378.5 L10.5,378.5 C7.46243388,378.5 5,376.037566 5,373 C5,369.962434 7.46243388,367.5 10.5,367.5 L54.777,367.5 L54.7777778,347.019415 C54.7777778,345.140486 56.2501778,343.605455 58.1040921,343.505208 Z"
        fill="#AAAAAA" fill-rule="nonzero" transform="translate(60.5, 373) scale(-1, 1) translate(-60.5, -373)" />
      <path
        id="Line-3"
        d="M437.297192,343 C437.843564,343 438.382433,343.12721 438.871123,343.371554 L490.831522,369.351754 C492.570037,370.221012 493.27471,372.335029 492.405452,374.073545 C492.064901,374.754648 491.512625,375.306923 490.831522,375.647475 L438.871123,401.627675 C437.132607,402.496932 435.01859,401.79226 434.149332,400.053744 C433.904987,399.565055 433.777778,399.026186 433.777778,398.479814 L433.777,378 L389.5,378 C386.462434,378 384,375.537566 384,372.5 C384,369.462434 386.462434,367 389.5,367 L433.777,367 L433.777778,346.519415 C433.777778,344.640486 435.250178,343.105455 437.104092,343.005208 Z"
        fill="#AAAAAA" fill-rule="nonzero" transform="translate(439.5, 372.5) scale(-1, 1) translate(-439.5, -372.5)" />
      <path
        id="Line-2"
        d="M437.297192,93.5 C437.843564,93.5 438.382433,93.6272096 438.871123,93.8715545 L490.831522,119.851754 C492.570037,120.721012 493.27471,122.835029 492.405452,124.573545 C492.064901,125.254648 491.512625,125.806923 490.831522,126.147475 L438.871123,152.127675 C437.132607,152.996932 435.01859,152.29226 434.149332,150.553744 C433.904987,150.065055 433.777778,149.526186 433.777778,148.979814 L433.777,128.5 L389.5,128.5 C386.462434,128.5 384,126.037566 384,123 C384,119.962434 386.462434,117.5 389.5,117.5 L433.777,117.5 L433.777778,97.0194147 C433.777778,95.1404863 435.250178,93.6054553 437.104092,93.5052076 Z"
        fill-rule="nonzero" />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
#Line-2 {
  .brand-va & {
    fill: #00917E;
  }

  .brand-sd & {
    fill: #CC0033;
  }
}
</style>
